<template>
    <v-app-bar color="primary" dense dark fixed app style="z-index: 99">
    
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" >
          <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-spacer></v-spacer>
          <v-toolbar-title>{{$t('general.confirmation')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text class="pa-4 text-center" style="font-size: 18px">
          {{$t('user.logoutConfirmation')}}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            :loading="$store.state.user.loading"
            color="primary"
            @click="$store.dispatch('user/logout')"
          >
            {{$t('general.yes')}}
          </v-btn>
          <v-btn
            :disabled="$store.state.user.loading"
            color="secondary"
            @click="dialog = false"
          >
            {{$t('general.no')}}
          </v-btn>
          <div class="flex-grow-1"></div>
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-spacer></v-spacer>
      <v-toolbar-title >
       Code : {{$store.getters['game/code']}} - {{$store.getters['company/name']}} {{$store.getters['company/week'] > 0 ? '- ' + $t('general.week') + ' ' + $store.getters['company/week'] : ''}}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="reloadPage">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-icon v-if="network" large color="green">
        mdi-wifi
      </v-icon>
      <v-icon v-else large color="red">
        mdi-wifi-off
      </v-icon>
    </v-app-bar>
</template>
<script>
export default {
  name: "Toolbar",
  data: () => ({
    network: true,
    dialog: false
  }),
  methods: {
    reloadPage () {
      location.reload()
    }
  },
  computed: {
    drawer: {
      get() {
        return this.$store.state.interfaceSettings.navigationDrawer;
      },
      set(newValue) {
        this.$store.commit("interfaceSettings/SET_navigationDrawer", newValue);
      }
    }
  },
  sockets: {
    connect: function () {
        this.network = true
        if (this.$store.state.game.data !== null) {
          this.$socket.emit("subscribe", this.$store.state.game.data._id);
        }
    },
    disconnect: function () {
        this.network = false
    }
  }
};
</script>
